"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ArrowDownCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11.49-.001c-6.309 0-11.5 5.191-11.5 11.5s5.191 11.5 11.5 11.5 11.5-5.191 11.5-11.5c-.005-6.307-5.193-11.495-11.5-11.5Zm0 20.844c-5.126 0-9.344-4.218-9.344-9.344 0-5.126 4.218-9.344 9.344-9.344 5.126 0 9.344 4.218 9.344 9.344-.003 5.125-4.219 9.341-9.344 9.344Z",
    fill: color
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M6.75 10.894a1.043 1.043 0 0 1 1.467 0l2.246 2.244V7.354c0-.569.468-1.037 1.037-1.037s1.037.468 1.037 1.037v5.784l2.246-2.244c.193-.184.449-.286.715-.286.57 0 1.038.468 1.038 1.037 0 .267-.103.524-.287.717l-4.016 4.013a1.039 1.039 0 0 1-1.467 0l-4.015-4.013a1.034 1.034 0 0 1 0-1.467l-.001-.001Z",
    fill: color
  })]
});

ArrowDownCircleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = ArrowDownCircleIcon;
exports.default = _default;